import React, { useState } from 'react';

import { Tooltip } from "./Tooltip/Tooltip";
import "./Tooltip/Tooltip.css";
import { FiltersDiv } from "./FiltersDiv/FiltersDiv";
import "./FiltersDiv/FiltersDiv.css";

import './Main.css';
import './SwitchTheme';
import CardHome from './CardHome/CardHome.js';
import AdvancedMenu from './AdvancedMenu.js';
import { randomHex, advancedSearch } from '../utility/Element.js';
import InfiniteScrollCard from './InfiniteScrollCard';
import PDFDocument from './PDFDocument';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import SideBar from './Sidebar.js';
import { 
  getBadges,
  getMainTags,
  getMainIngredients,
	getMainCredits,
  getBlogger,
} from '../model/recipe/recipeSlice';
import { 
  getNavigations,
  addNavigation,
} from '../model/navigation/navSlice';
import {
  setSearchFilter,
  setSearchFilterText,
} from '../model/searchFilter/searchFilterSlice';
import { useSelector, useDispatch } from 'react-redux';
var cache = {}
  window.excludedFilterView = {
    "ingredients": [], 
    "tags": [], 
    "badges": [],
    "credits": []
  }
const Main = () => {
  const dispatch = useDispatch();
  let credits = useSelector(getBlogger);
  let navigations = useSelector(getNavigations);
  let resto = undefined;
  if (credits === 'teonzo') {
    resto = require.context('../json/teonzo/', true, /\.json$/);
  } else if (credits === 'piante') {
    resto = require.context('../json/piante/', true, /\.json$/);
  } else {
    resto = require.context('../json/', false, /\.json$/);
  }
  const [filterView, setFilterView] = useState();
  const [selectFilter, setSelectFilter ] = useState({
    "ingredients": [], 
    "preparation": undefined, 
    "tags": [], 
    "badges": [], 
    "credits": [], 
  });
  const [checkEsistenzaFiltro, setCheckEsistenzaFiltro] = useState(false);
  const [searchText, setSearchText] = useState();
  const allCredits = useSelector(getMainCredits);
  const badges = useSelector(getBadges);
  const tags = useSelector(getMainTags);
  const ingredients = useSelector(getMainIngredients);
  const [themeState, setThemeState] = useState(false);
  const [showPDF, setShowPDF] = useState(false);
  const [pdfPreview, setPdfPreview] = useState([]);
  const [cacheKey] = useState([]);
  const [searchedRecipe, setSearchedRecipe] = useState({});
  const advancedMenuCallback = (filter, text, isSearchText) => {
    if (isSearchText === 'restore'){
      resetFilterView();
      filter.text = text;
      setSearchText(text);
      setSelectFilter({...filter});
    } else if(isSearchText) {
      filter = { ...selectFilter };
      filter.text = text;
      setSearchText(text);
    } else {
      setSelectFilter({...filter});
      filter.text = searchText;
    }
    dispatch(setSearchFilter(filter))
    dispatch(setSearchFilterText(filter.text))
    window.searchFilterView = {...filter};
    let searchedEle = undefined;
    if (filter) {
      searchedEle = cacheKey.map((key, i) => {
        const recipe = { ...cache[key] };
        const searchResult = advancedSearch(filter, recipe);
        if (searchResult.preparations.length > 0) {
          searchResult.id = key;
          return searchResult;
        }
        return undefined;
      }).filter((x) => {
        visitaRicetta(x);
        return x !== undefined;
      }).sort((a, b) => {
        return b.score - a.score;
      });
    }
    setSearchedRecipe(searchedEle);
  }
  const inputCallback = (themeState) => {
    for (var i = tags.length - 1; i >= 0; i--) {
      let tag = tags[i];
      if (tag.selected) {
        tag.props = {
          style: {
            cursor: 'pointer',
            backgroundColor: themeState ? randomHex('white') : randomHex('black'),
            color: themeState ? 'white' : 'black',
          },
        }
      } else {
        tag.props = {
          style: {
            cursor: 'pointer',
            color: themeState ? randomHex('white') : randomHex('black'),
          }
        }
      }
    }
    setThemeState(themeState);
  }
  function visitaRicetta(x) {
    if ( x === undefined )
      return;
    var badgeVisto = { value: "visto", label: "visto", retrieved: true };
    if (x.badges === undefined) {
      x.badges = [];
    }
    var time = 0;
    if (x.date){
      var splittedA = x.date.split('-');
      time =  new Date(splittedA[2], splittedA[1], splittedA[0]).getTime()
    }
    let value = x.score ? x.score : time; 
    if (x && (!x.visited || x.searched) && navigations.navs.includes(x.id.substring(0, x.id.indexOf(".json")))) {
      if (!x.badges.some(elemento => elemento.value === badgeVisto.value))
        x.badges.unshift(badgeVisto);
      x.score = 500000 * 10000 + value; 
      x.visited = true;
      console.log(x.id, x.score);
    }
  }

  const handlePDFPreview = (key) => {
    setShowPDF(true);
    setPdfPreview(cache[key+'.json']);
  };

  const importAll = (r) => {
    cache = {};
    r.keys().sort((a, b) => {
      const rA = r(a);
      const rB = r(b);
      rA.id = a.substring(2);
      rB.id = b.substring(2);
      visitaRicetta(rA);
      visitaRicetta(rB);
      if (rA.date === undefined )
        return 1;
      if (rB.date === undefined )
        return -1;
      var splittedA = rA.date.split('-');
      var splittedB = rB.date.split('-');
      let date1 = new Date(splittedA[2], splittedA[1], splittedA[0]).getTime();
      let date2 = new Date(splittedB[2], splittedB[1], splittedB[0]).getTime();
      if (rA.score && rB.score)
        return rB.score - rA.score;
      if (rA.score)
        return -1;
      if (rB.score)
        return 1;
      if (date1 > date2) {
        return -1;
      } else if (date1 < date2) {
        return 1;
      } else {
        return rA.title.localeCompare(rB.title)
      }

    }).forEach((key, i) => {
      (cache[key.substring(2)] = r(key));
      cache[key.substring(2)].id = key.substring(2);
    });
    cacheKey.splice(0, cacheKey.length);
    cacheKey.push(...Object.keys(cache));
  }
  importAll(resto);
  window['inputCallback'] = inputCallback;
  window['pdfPreview'] = handlePDFPreview;
  var keys = [...cacheKey];

  function mergeArray(array1, array2) {
      let arrayMerge = array1.concat(array2)
      return arrayMerge.filter( (item, index) =>
          arrayMerge.indexOf(item) === index
      )
  }
  const resetFilterView = () => {
    window.excludedFilterView = {
			"ingredients": [], 
			"tags": [], 
			"badges": [],
			"credits": [],
		};
    window.searchFilterView = {
			"ingredients": [], 
			"tags": [], 
			"badges": [],
			"credits": [],
		};
  }
  React.useEffect(() => {
    setFilterView({
      ingredients: mergeArray(window.searchFilterView["ingredients"]||[], window.excludedFilterView["ingredients"]||[] ),
      tags: mergeArray(window.searchFilterView["tags"]||[], window.excludedFilterView["tags"]||[] ),
      badges: mergeArray(window.searchFilterView["badges"]||[], window.excludedFilterView["badges"]||[] ),
      credits: mergeArray(window.searchFilterView["credits"]||[], window.excludedFilterView["credits"]||[] )
    });
  },[selectFilter]);
  const controllaFiltro = () => {
    if (!filterView)
      return false;
    if (filterView["badges"].length !== 0 || filterView["ingredients"].length !== 0 || filterView["tags"].length !== 0  || filterView["credits"].length !== 0)
      return true;
    return false;
}
  React.useEffect(() => {
    setCheckEsistenzaFiltro(controllaFiltro());
  },[filterView]);

  function recuperaLabelBadges(ids) {
    var label = "";
    badges.forEach((i)=>{
      if (ids.includes(i.value)) {
        label += i.value + "|" + i.label + ",";
      }
    })
    return label.substring(0,label.length - 1);
  }

  function recuperaLabelIngredienti(ids) {
    var label = "";
    ingredients.forEach((i)=>{
      if (ids.includes(i.value.id)) {
        label += i.value.id + "|" + i.label + ",";
      }
    })
    return label.substring(0,label.length - 1);
  }
  React.useEffect(() => {
  },[themeState])
  return ([
        <div key={"main"}>
        { (showPDF && pdfPreview) ?
          <div key="PDFViewer" id="PDFViewer" onClick={() => {setShowPDF(false)}} className="pdf-viewer-container">
            <PDFViewer className="pdf-viewer">
              <PDFDocument ricetta={pdfPreview} />
            </ PDFViewer>
            <PDFDownloadLink document={<PDFDocument ricetta={pdfPreview} />} className="pdf-download btn" fileName={pdfPreview.title}>
              {({ blob, url, loading, error }) =>
                loading ? 'Loading document...' : 'Download now!'
              }
            </ PDFDownloadLink>
          </ div> : 

          <></>
        }
        </div>,
        <AdvancedMenu key="0" ingredients={ingredients} tags={tags} badges={badges} credits={allCredits} callback={advancedMenuCallback} tema={themeState} />,
        <main key="1">
          <SideBar callback={advancedMenuCallback} />
        <div className='card-home-container'>
          <div id="cardCategories">
            {
              badges.map((badge) => {
                return (
                  <CardHome key={badge.value} value={`${badge.value}`}/>
                )
              })
            }
          </div>

          <div id='goToSearch' style={{width: '100%', scrollMarginTop: '80px'}}></div>
          <details>
            <summary className='unselectable' style={{position:'relative'}} onClick={() => {document.getElementById('svgFilterSearchActive').classList.toggle('hidden');document.getElementById('svgFilterSearch').classList.toggle('hidden')}}> 
              <span className='filtriSpan'>
                <svg id='svgFilterSearch' 
                    style={{verticalAlign:"middle"}} fill={themeState?'#161616':'#fff'} 
                    width="80" height="80" viewBox="-3.2 -3.2 35 35"
                    version="1.1"  xmlns="http://www.w3.org/2000/svg"
                    stroke="#000000" stroke-width="0.00032" 
                    transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)scale(-1,1)">
                    <g id="SVGRepo_iconCarrier"> 
                        <g transform="matrix(1,0,0,1,-240,-96)"> 
                            <path d="M256.1,105L244,105C243.448,105 243,105.448 243,106C243,106.552 243.448,107 244,107L256.1,107C256.564,109.281 258.583,111 261,111C263.417,111 265.436,109.281 265.9,107L268,107C268.552,107 269,106.552 269,106C269,105.448 268.552,105 268,105L265.9,105C265.436,102.719 263.417,101 261,101C258.583,101 256.564,102.719 256.1,105ZM261,103C262.656,103 264,104.344 264,106C264,107.656 262.656,109 261,109C259.344,109 258,107.656 258,106C258,104.344 259.344,103 261,103Z" fill="#000000;"></path> 
                            <path d="M246.1,117L244,117C243.448,117 243,117.448 243,118C243,118.552 243.448,119 244,119L246.1,119C246.564,121.281 248.583,123 251,123C253.417,123 255.436,121.281 255.9,119L268,119C268.552,119 269,118.552 269,118C269,117.448 268.552,117 268,117L255.9,117C255.436,114.719 253.417,113 251,113C248.583,113 246.564,114.719 246.1,117ZM251,115C252.656,115 254,116.344 254,118C254,119.656 252.656,121 251,121C249.344,121 248,119.656 248,118C248,116.344 249.344,115 251,115Z" fill="#000000;"></path> 
                        </g> 
                    </g>
                </svg>
                <svg id='svgFilterSearchActive'
                    className="hidden" style={{verticalAlign:"middle"}} fill={themeState?'#161616':'#fff'}
                    width="80" height="80" viewBox="-3.2 -3.2 35 35"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" 
                    stroke="#000000" stroke-width="0.00032"
                    transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)">
                    <g id="SVGRepo_iconCarrier">
                        <g transform="matrix(1,0,0,1,-240,-96)">
                            <g transform="matrix(1.33333,0,0,1.33333,-28.3333,-35.3333)">
                                <circle cx="217" cy="106" r="3" style={{fill:themeState?"#3185a0":"#dc7800ff"}}></circle>
                            </g>
                            <g transform="matrix(-1.33333,0,0,1.33333,540.333,-23.3333)">
                                <circle cx="217" cy="106" r="3" style={{fill:themeState?"#3185a0":"#dc7800ff"}}></circle>
                            </g>
                            <path
                                d="M256.1,105L244,105C243.448,105 243,105.448 243,106C243,106.552 243.448,107 244,107L256.1,107C256.564,109.281 258.583,111 261,111C263.417,111 265.436,109.281 265.9,107L268,107C268.552,107 269,106.552 269,106C269,105.448 268.552,105 268,105L265.9,105C265.436,102.719 263.417,101 261,101C258.583,101 256.564,102.719 256.1,105ZM261,103C262.656,103 264,104.344 264,106C264,107.656 262.656,109 261,109C259.344,109 258,107.656 258,106C258,104.344 259.344,103 261,103Z"></path>
                            <path
                                d="M246.1,117L244,117C243.448,117 243,117.448 243,118C243,118.552 243.448,119 244,119L246.1,119C246.564,121.281 248.583,123 251,123C253.417,123 255.436,121.281 255.9,119L268,119C268.552,119 269,118.552 269,118C269,117.448 268.552,117 268,117L255.9,117C255.436,114.719 253.417,113 251,113C248.583,113 246.564,114.719 246.1,117ZM251,115C252.656,115 254,116.344 254,118C254,119.656 252.656,121 251,121C249.344,121 248,119.656 248,118C248,116.344 249.344,115 251,115Z"></path>
                        </g>
                    </g>
                </svg>
              </span>
              <span style={{position: "relative", display: "inline-block", verticalAlign: "middle"}}>
                <div className={!checkEsistenzaFiltro ? 'filter-view-testo' : ''}>
                  {(searchedRecipe === undefined || searchedRecipe.length === 0) ? keys.length : searchedRecipe.length} ricette recuperate
                </div>
                <div>
              {(filterView!=null && filterView['badges'] != null && filterView['badges'].length !== 0) ?
                <Tooltip text={`${recuperaLabelBadges(filterView['badges'])}`} placement="bottom" titolo="Categorie">
                  <span key="BadgeFiltriViewSpan" className='filtriSpan'>
                    <img height="35" key="BadgeFiltriViewImg" src={`/images/filtri/categories.png`} alt="Icona badge" ></img>
                  </span>
                </Tooltip>
                :
                <></>
              }
              {(filterView!=null && filterView['tags'] != null && filterView['tags'].length !== 0) ?
                <Tooltip text={`${filterView['tags']}`} placement="bottom" titolo="Tag">
                <span key="TagFiltriViewSpan" className='filtriSpan'>
                  <img height="35" key="TagFiltriViewImg" src={`/images/filtri/hashtag.png`} alt="Icona TAG" ></img>
                </span> 
                </Tooltip>
                :
                <></>
              }
              {(filterView!=null && filterView['ingredients'] != null && filterView['ingredients'].length !== 0) ?
                <Tooltip text={`${recuperaLabelIngredienti(filterView['ingredients'])}`} placement="bottom" titolo="Ingredienti">
                  <span key="IngredientiFiltriViewSpan" className='filtriSpan'>
                    <img height="35" key="IngredientiFiltriViewImg" src={`/images/filtri/ingredients.png`} alt="Icona INGREDIENTI" ></img>
                  </span> 
                </Tooltip>
                :
                <></>
              }
              {(filterView!=null && filterView['credits'] != null && filterView['credits'].length !== 0) ?
                <Tooltip text={`${filterView['credits']}`} placement="bottom" titolo="credit">
                <span key="CreditsFiltriViewSpan" className='filtriSpan'>
                  <img height="35" key="CreditsFiltriViewImg" src={`/images/filtri/credits.png`} alt="Icona Autori" ></img>
                </span> 
                </Tooltip>
                :
                <></>
              }
              </div>
              </span>
            </summary>
            <section id="section" class="section">
              {(filterView!=null) ? 
                <FiltersDiv 
                    callback={advancedMenuCallback}
                    categorie={`${recuperaLabelBadges(filterView['badges'])}`} 
                    ingredienti={`${recuperaLabelIngredienti(filterView['ingredients'])}`} 
                    tags={`${filterView['tags']}`}
                    credits={`${filterView['credits']}`}>

                </FiltersDiv>
                :
                <></>
              }
            </section>
          </details>
          {
            (searchedRecipe === undefined || searchedRecipe.length === 0) ?
              <InfiniteScrollCard 
              key={keys.length}
                credits={credits} 
                cache={cache}
                cacheKey={keys}
              />
              : themeState ?
                <InfiniteScrollCard 
                  key={Object.keys(searchedRecipe).length}
                  credits={credits} 
                  cache={searchedRecipe}
                  cacheKey={Object.keys(searchedRecipe)}
                />
                :
                <InfiniteScrollCard 
                  key={Object.keys(searchedRecipe).length}
                  credits={credits} 
                  cache={searchedRecipe}
                  cacheKey={Object.keys(searchedRecipe)}
                />
          }
        </div>

      </main>]
  );


}

export default Main;